import { ArrowBackBriefIcon, CloseIcon } from "@mgdx/ui/components/Icon";
import { IconButton } from "@mgdx/ui/components/IconButton";
import { RefreshButton } from "@mgdx/ui/components/RefreshButton";
import { Title } from "@mgdx/ui/components/Title";
import { type KeyboardEvent, type MouseEvent, type PropsWithChildren } from "react";

import styles from "./index.module.css";

export type Props = PropsWithChildren<{
  title?: string;
  /** 見出しの id。Modal の aria-labelledby から参照する */
  titleId?: string;
  onRequestBack?: (event: MouseEvent | KeyboardEvent) => void;
  onRequestClose?: (event: MouseEvent | KeyboardEvent) => void;
  onRequestRefresh?: (event: MouseEvent | KeyboardEvent) => void;
}>;

export const DialogLayout = ({ title, titleId, onRequestBack, onRequestClose, onRequestRefresh, children }: Props) => {
  return (
    <div className={styles.layout}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {onRequestBack && (
            <IconButton variant="subtle" color="secondary" size="s" aria-label="戻る" onClick={onRequestBack}>
              <ArrowBackBriefIcon />
            </IconButton>
          )}
        </div>

        <Title as="h2" id={titleId} fontSize="m" className={styles.headerCenter}>
          {title}
        </Title>

        <div className={styles.headerRight}>
          {onRequestRefresh && <RefreshButton variant="subtle" size="s" onClick={onRequestRefresh} />}

          {onRequestClose && (
            <IconButton variant="subtle" size="s" color="secondary" aria-label="閉じる" onClick={onRequestClose}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </div>

      <div className={styles.content}>{children}</div>
    </div>
  );
};
